import Analyst from '@reaction-club/analyst-client'
import LocalStorage from '@reaction-club/analyst-client/storage/LocalStorage'
import config from '../config'

const analyst = new Analyst({
  storage: new LocalStorage(),
  app_key: config.analyst.key,
  url: config.analyst.url,
})

analyst.init()

export default analyst
